import InputType from "@/services/Input/InputType.js";
import Catalog from "../RtnInvoiceCatalog.js";

// see details: "@/services/Input/DataCatalog.js"
export default {
  Search: {
    Label: "Cari " +
      Catalog.ReturnNumber.Label + ", atau " +
      Catalog.SONumber.Label + ", atau " +
      Catalog.ClientID.Label,
    Type: InputType.Text,
    MaxLength: 50
  },
  WarehouseID: {
    Label: Catalog.WarehouseID.Label,
    Type: InputType.ID,
    Input: InputType.Select
  },
  Date: {
    Label: Catalog.Date.Label,
    Type: InputType.Date,
    IsRange: true,
    Required: true,
    RequiredHide: true
  }
}